<script>
import PageHeader from "@/components/layout/PageHeader";
import PageContent from "@/components/layout/PageContent";
import PageFooter from "@/components/layout/PageFooter";

export default {
  name: "Page",
  components: {
    PageHeader,
    PageContent,
    PageFooter
  }
};
</script>
